<template>
  <section class="mx-auto px-4 max-w-6xl match-to-scroll-to">
    <h3 class="text-center block mb-4 mt-10 text-base text-brandGrey">
    <span>
        {{ date }}
      </span>
    </h3>
    <div class="space-y-4 md:space-y-0 md:flex flex-wrap justify-center">
      <div v-for="(match, index) in matches" :key="index" class="md:contents">
        <FreemiumCard
          v-if="match.casual_blurred_match"
          class="blur-freemium"
          :key="index"
          :index="index"
          :match="match"
          :gameCount="gameCount"
          :competition="competition"
          :oddsType="oddsType"
          :mode="mode"
        />
        <Card
          v-else-if="(match.freemium_match || subType == 'active')"
          :key="index"
          :index="index"
          :match="match"
          :gameCount="gameCount"
          :competition="competition"
          :oddsType="oddsType"
          :mode="mode"
        />
        <FreemiumCard
          v-else-if="!match.freemium_match"
          class="blur-freemium"
          :key="index"
          :index="index"
          :match="match"
          :gameCount="gameCount"
          :competition="competition"
          :oddsType="oddsType"
          :mode="mode"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Card from "../components/Card";
import FreemiumCard from "./FreemiumCard.vue";

export default {
  name: "MatchDay",
  props: ["date", "matches", "mode", "competition", "oddsType", "index", "subType"],
  components: {
    Card,
    FreemiumCard
  },
  computed: {
    gameCount() {
      return this.matches.length;
    },
  },
};
</script>
